import { defineEvents, SHARED_EVENTS } from '@3plearning/mx-teacher-analytics';

export const ANALYTICS_EVENTS = {
    pageView: 'page.view',
    routeViewed: 'route.viewed',
    actionClick: 'action.click',
    actionCompleted: 'action.completed'
};

export const ANALYTICS_MODULES = {
    quickUpload: 'quick_upload',
    students: 'students',
    teachers: 'teachers',
    manageDefaultCourses: 'manage_default_courses',
    manageAssignedCourses: 'manage_assigned_courses',
    teacherView: 'teacher_view',
    rollover: 'rollover',
    downloadCertificates: 'download_certificates',
    signInCards: 'sign_in_cards',
    extendResult: 'extend_result'
};

export default defineEvents({
    ...SHARED_EVENTS,
    [ANALYTICS_EVENTS.pageView]: {
        group: 'navigation',
        props: {}
    },
    [ANALYTICS_EVENTS.routeViewed]: {
        group: 'navigation',
        props: {}
    },
    [ANALYTICS_EVENTS.actionClick]: {
        group: 'school_roll',
        props: {}
    },
    [ANALYTICS_EVENTS.actionCompleted]: {
        group: 'school_roll',
        props: {}
    }
});



// WEBPACK FOOTER //
// ./app/analytics/events.js